// extracted by mini-css-extract-plugin
export default {"code":"ContactPage2_code__UsxWS","line":"ContactPage2_line__wK7N5","className":"ContactPage2_className__jMRic"};